import { LanguageSelection } from '@/components/screens/LanguageSelection'
import { useInterviewSessionContext } from '@/context/InterviewSessionContext'

export function LanguageScreen() {
  const { handleSelectLanguage, handleBackToHome } = useInterviewSessionContext()
  return <LanguageSelection onSelect={handleSelectLanguage!} onBack={handleBackToHome} />
}